import { render, staticRenderFns } from "./settingActivity.vue?vue&type=template&id=22958c1a&scoped=true"
import script from "./settingActivity.vue?vue&type=script&lang=js"
export * from "./settingActivity.vue?vue&type=script&lang=js"
import style0 from "./settingActivity.vue?vue&type=style&index=0&id=22958c1a&prod&lang=scss"
import style1 from "./settingActivity.vue?vue&type=style&index=1&id=22958c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22958c1a",
  null
  
)

export default component.exports